export const addSuffixToFieldName = (fieldName: string, suffix: string) =>
  fieldName.endsWith(']')
    ? `${fieldName.slice(0, -1)}${suffix}]`
    : `${fieldName}${suffix}`;

export const addPrefixToFieldName = (fieldName: string, prefix: string) => {
  const lastBracketIndex = fieldName.lastIndexOf('[');

  if (lastBracketIndex === -1) {
    // Simple field name, just add prefix
    return `${prefix}${fieldName}`;
  }

  // Nested field name, add prefix to the innermost field
  const beforeLastBracket = fieldName.slice(0, lastBracketIndex + 1);
  const afterLastBracket = fieldName.slice(lastBracketIndex + 1);

  return `${beforeLastBracket}${prefix}${afterLastBracket}`;
};

export const surroundFieldNameWith = (
  fieldName: string,
  prefix: string,
  suffix: string,
) => addPrefixToFieldName(addSuffixToFieldName(fieldName, suffix), prefix);
